
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { EmbeddedContent } from 'client-website-ts-library/types/EmbeddedContent/EmbeddedContent';

@Component
export default class Embeddable extends Vue {
  @Prop({ required: true })
  private readonly embeddable!: EmbeddedContent;

  @Prop({ default: false })
  private readonly radius!: boolean;

  private readonly origin: string = window.location.origin;
}
